import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import Person2OutlinedIcon from '@mui/icons-material/Person2Outlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { useCallback, useState } from 'react';
import { useAuthCore } from '../../core/modules/auth';
import { useMeCore } from '../../core/modules/me';
import { useTranslation } from 'react-i18next';
import { useGlobalCore } from '../../core/modules/global';
import { ME_PASSWORD_DIALOG, ME_USER_DIALOG } from '../../core/constants/dialog';
import PasswordOutlinedIcon from '@mui/icons-material/PasswordOutlined';

const UserMenu = () => {
  const { t } = useTranslation();

  const { logout } = useAuthCore();
  const { user, getMeUser } = useMeCore();
  const { openDialog } = useGlobalCore();

  const [userMenu, setUserMenu] = useState(null);

  const userMenuClick = (e: any) => {
    setUserMenu(e.currentTarget);
  };

  const userMenuClose = () => {
    setUserMenu(null);
  };

  const onEditMe = useCallback(() => {
    userMenuClose();
    getMeUser();
    openDialog(ME_USER_DIALOG);
  }, [getMeUser, openDialog]);

  const onEditPassword = useCallback(() => {
    userMenuClose();
    openDialog(ME_PASSWORD_DIALOG);
  }, [openDialog]);

  const onLogout = useCallback(() => {
    userMenuClose();
    logout();
  }, [logout]);

  return (
    <>
      <Button
        className="min-h-40 min-w-40 px-0 md:px-16 py-0 md:py-6"
        onClick={userMenuClick}
        color="inherit"
      >
        <div className="hidden md:flex flex-col mx-4 items-end">
          <Typography component="span" className="font-semibold flex">
            {user?.full_name}
          </Typography>
          {user?.is_superuser && (
            <Typography
              className="text-11 font-medium capitalize"
              color="text.secondary"
            >
              {t('user.role.admin')}
            </Typography>
          )}
        </div>

        {user?.avatar ? (
          <Avatar className="md:mx-4" alt="user avatar" src={user.avatar} />
        ) : (
          <Avatar className="md:mx-4">
            {user?.full_name[0]}
          </Avatar>
        )}
      </Button>

      <Popover
        open={Boolean(userMenu)}
        anchorEl={userMenu}
        onClose={userMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        classes={{
          paper: 'py-8',
        }}
      >
        <MenuItem onClick={onEditMe}>
          <ListItemIcon className="min-w-40">
            <Person2OutlinedIcon />
          </ListItemIcon>
          <ListItemText primary={t('toopbar.menu.profile')} />
        </MenuItem>
        <MenuItem onClick={onEditPassword}>
          <ListItemIcon className="min-w-40">
            <PasswordOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Cambiar Contraseña" />
        </MenuItem>
        <MenuItem onClick={onLogout}>
          <ListItemIcon className="min-w-40">
            <LogoutOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary={t('toopbar.menu.signout')} />
        </MenuItem>
      </Popover>
    </>
  );
};

export default UserMenu;
